/* eslint-disable jsx-a11y/anchor-is-valid */
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { FC, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import PartyDetails from '../../../PartyDetails'
import translations from '../../../../../../translations/en.json'
import { ID } from '../../../../../../_metronic/helpers'
import { MenuComponent } from '../../../../../../_metronic/assets/ts/components'
import { setMessage } from '../../../../../../store/alertMessage/actions'
import { updateParty } from '../../core/_requests'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import Deleteparty from '../../../DeleteParty'
import EditPartyModal from '../../party-add-edit/PartyEditModal'
import { useNavigate } from 'react-router-dom'

type Props = {
  id: ID
  values: any
  data: any
}

const PartyActionsCell: FC<Props> = ({ id, data }) => {
  const { setItemIdForUpdate } = useListView()
  console.log("Idd ---> ", id, data)
  // const { query } = useQueryResponse()
  // const queryClient = useQueryClient()
  const { refetch } = useQueryResponse()
  const dispatch = useDispatch()
  const [ShowDeletePartyModal, setShowDeletePartyModal] = useState<any>(false)
  const [ShowPartyDetailsModal, setShowPartyDetailsModal] = useState<boolean>(false)
  const [ShowPartyDeviceResetModal, setShowPartyDeviceResetModal] = useState<boolean>(false)
  const [ShowPartyOtpModal, setShowPartyOtpModal] = useState<boolean>(false)
  const [ShowPartyTempDrCr, setShowPartyTempDrCr] = useState<boolean>(false)
  const [ShowPartyTempTimingModal, setShowPartyTempTimingModal] = useState<boolean>(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedParty, setSelectedParty] = useState<any>(null)
  const [isActive, setIsActive] = useState(data.is_active)
  const navigate = useNavigate()
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const cityList = useSelector((state: any) => state.commonList.cityList)
  const isAdmin = cityList?.roleInfo?.id === 1 || cityList?.roleInfo?.id === 2
  const isPartyViewPermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.party_is_view === true

  const isPartyDeletePermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.party_is_delete === true
  const isPartyEditPermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.party_is_edit === true

  useEffect(() => {
    setIsActive(data.is_active)
  }, [data.is_active])

  const toggleActive = async () => {
    const updatedIsActive = !isActive
    const d = updatedIsActive === true ? 1 : 0
    try {
      const values = {
        is_active: d,
      }
      const updateData = await updateParty(values, id)
      if (updateData?.statusCode === 200 || updateData?.responseStatus === 200) {
        dispatch(setMessage('success', updateData?.message ?? updateData?.responseMessage))
        refetch()
      } else {
        dispatch(
          setMessage(
            'error',
            updateData?.responseData?.msg
              ? updateData?.responseData?.msg
              : updateData?.responseMessage
          )
        )
      }
    } catch (error) {
      console.error(error)
    }
    setIsActive(updatedIsActive)
  }
  // const { config } = useLayout()
  // const openEditPartyModal = () => {
  //   setItemIdForUpdate(id)
  //   console.log("Update  Id --> ", setItemIdForUpdate(id))
  // }
  const handleEditClick = () => {
    setItemIdForUpdate(id)
    // navigate(`/party/add-party/${data.partyId}`)
    navigate('/partys/add-party', { state: { partyId: data.partyId } })
    // setSelectedParty(data)
    // setShowEditModal(true)
  }

  

  return (
    <>
      <div
        className='d-flex justify-content-center align-items-center menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 py-2'
        data-kt-menu='true'
      >

        <>
          <div className='menu-item'>
            <a className='menu-link' onClick={handleEditClick}>
              <OverlayTrigger
                placement='top'
                overlay={
                  <Tooltip className='py-2 px-2 fs-5 '>{translations.labels.edit}</Tooltip>
                }
              >
                <i className='fa-sharp fa-solid fa-pen fs-5 text-success'></i>
              </OverlayTrigger>
            </a>
          </div>
          {/* Edit Party Modal */}
          {/* {showEditModal && (
            <EditPartyModal
              show={showEditModal}
              onHide={() => setShowEditModal(false)}
              partyData={selectedParty}
            />
          )} */}
        </>

      </div>
    </>
  )
}

export { PartyActionsCell }
